import React from "react"

import GenericResourceImageCard from "~components/shared/todo-lib-react-components/image-card/generic-resource-image-card"
import LoadingOrErrorContainer from "~components/shared/todo-lib-react-components/loading-or-error-container"
import type { ResourceFieldsFragment } from "~graphql/generated/graphql"
import useResource from "~utils/use-resource"

export default function IncludedResource({
    resourceId,
    onClick,
}: {
    readonly resourceId: string | null
    readonly onClick: (resource: ResourceFieldsFragment) => void
}) {
    const { resource, isLoading, error } = useResource({ resourceId })

    return (
        <LoadingOrErrorContainer
            error={error}
            isLoading={isLoading}
            shouldRenderChildren={!!resource}
        >
            <GenericResourceImageCard
                resource={resource}
                handleClick={onClick}
            />
        </LoadingOrErrorContainer>
    )
}
